import moment from 'moment';

export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
export const DEFAULT_DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';
export const DEFAULT_DATE_TIME_GANTT_FORMAT = 'DD-MM-YYYY HH:mm';

/**
 * Format using the default 'DD-MM-YYYY'
 * @param {*} date 
 */
export const formatDateDefault = (date) => {
    return formatDate(date, DEFAULT_DATE_FORMAT);
};

/**
 * 
 * @param {*} date
 * @param {*} format 
 */
export const formatDate = (date, format) => {
    if (date && format) {
        return moment(date).format(format);
    }
    return date;
};

/**
 * Format using the default 'DD/MM/YYYY HH:mm'
 * @param {*} date 
 */
export const formatDateTimeDefault = (date) => {
    return formatDate(date, DEFAULT_DATE_TIME_FORMAT);
};

/**
 * Format using the default 'DD/MM/YYYY HH:mm'
 * @param {*} date 
 */
export const formatDateGanttChartDefault = (date) => {
    return formatDate(date, DEFAULT_DATE_TIME_GANTT_FORMAT);
};

/**
 * i.e converts 1830 to 1 day 6 hrs 30 mins
 * @param {} durationInMinutes 
 */
export const formatDurationAsDaysHrsMins = (durationInMinutes) => {
    // const hour = Math.floor(durationInMinutes / 60);
    // const min = Math.floor(durationInMinutes % 60);
    // const displayHour = hour > 0 ? `${hour} hr${hour > 1 ? 's' : ''} ` : '';
    // const displayMin = min > 0 ? `${min} min${min > 1 ? 's' : ''}` : '';
    // return displayHour.concat(displayMin);
    const days = Math.floor(durationInMinutes / 1440);
    const daysRemainder = (durationInMinutes / 1440) - Math.floor(durationInMinutes / 1440);
    const hour = Math.floor(daysRemainder * 24);
    const min = Math.floor(durationInMinutes % 60);
    const displayDay = days > 0 ? `${days} day${days > 1 ? 's' : ''} ` : '';
    const displayHour = hour > 0 ? `${hour} hr${hour > 1 ? 's' : ''} ` : '';
    const displayMin = min > 0 ? `${min} min${min > 1 ? 's' : ''}` : '';
    return displayDay.concat(displayHour).concat(displayMin).trim() || 0;
};





// WEBPACK FOOTER //
// ./services/DateFormatters.js